import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { ClubState, QcClubResponse } from '../models/clubs.models';

export const PanelStatusChanged = createAction('[Clubs: Search]: Panel Status Changed');

export const ClubNameChanged = createAction('[Clubs: Search]: Club Name Changed', props<{ clubName: string }>());

export const ClubCodeChanged = createAction('[Clubs: Search]: Club Code Changed', props<{ clubCode: string }>());

export const ClubStartDateChanged = createAction(
  '[Clubs: Search]: Club Start Date Changed',
  props<{ clubStartDate: Date; clubStartDateFormat: string }>(),
);

export const ClubStartDateCleared = createAction('[Clubs: Search]: Club Start Date Cleared');

export const ClubEndDateChanged = createAction(
  '[Clubs: Search]: Club End Date Changed',
  props<{ clubEndDate: Date; clubEndDateFormat: string }>(),
);

export const ClubEndDateCleared = createAction('[Clubs: Search]: Club End Date Cleared');

export const ShowInactiveClubsChanged = createAction('[Clubs: Search]: Show Inactive Clubs: Search Changed');

export const SearchClubs = createAction('[Clubs: Search]: Search Clubs: Search');

export const SearchClubsSuccess = createAction(
  '[Clubs: Search]: Search Clubs: Search Success',
  props<{ res: QcResponseGrid }>(),
);

export const SearchClubsFailed = createAction(
  '[Clubs: Search]: Search Clubs: Search Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const DeleteClubConfirm = createAction('[Clubs: Search]: Search Clubs: Delete Club Confirm');

export const DactivateClub = createAction('[Clubs: Search]: Delete Club');

export const DactivateClubSuccess = createAction(
  '[Clubs: Search]: Delete Club Success',
  props<{ res: QcClubResponse }>(),
);

export const DactivateClubFailed = createAction(
  '[Clubs: Search]: Delete Club Failed',
  props<{ error: HttpErrorResponse }>(),
);
export const EditClub = createAction('[Clubs: Search]: Edit Club', props<{ row: ClubState }>());

export const EditClubSuccess = createAction('[Clubs: Search]: Edit Club Success', props<{ res: QcResponseGrid }>());

export const EditClubFailed = createAction('[Clubs: Search]: Edit Club Failed', props<{ error: HttpErrorResponse }>());

export const ActivateClub = createAction('[Clubs: Search]: Activate Club', props<{ row: ClubState }>());

export const ActivateClubSuccess = createAction(
  '[Clubs: Search]: Activate Club Success',
  props<{ res: QcResponseGrid }>(),
);

export const ActivateClubFailed = createAction(
  '[Clubs: Search]: Activate Club Faild',
  props<{ error: HttpErrorResponse }>(),
);

export const ClearClubsFilters = createAction('[Clubs: Search]: Clear Clubs Filters');
